
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as QGpzLWpvZGEvdGltZXpvbmU from '@js-joda/timezone';
import * as d2FzbTpqcy1zdHJpbmc from './AnimapApp-app-webApp.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;
const _ref_QGpzLWpvZGEvdGltZXpvbmU_ = QGpzLWpvZGEvdGltZXpvbmU;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_0' : (f, trampoline) => getCachedJsObject(f, () => trampoline(f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_1' : (f, trampoline) => getCachedJsObject(f, (p0) => trampoline(f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.js.Promise_$external_class_instanceof' : (x) => x instanceof Promise,
    'kotlin.js.Promise_$external_class_get' : () => Promise,
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
    'kotlin.uuid.get' : (array, index) => array[index],
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'kotlinx.coroutines.internal.throwAsyncJsError' : (message, className, stack) => { 
            var error = new Error();
            error.message = message;
            error.name = className;
            error.stack = stack;
            if (typeof globalThis.reportError === 'function') {
                // Up-to-date browsers and some non-browser JS runtimes (Deno, Bun)
                globalThis.reportError(error);
            } else {
                // Fallback for old browsers (pre-2022), Node.js
                setTimeout(function () { throw error }, 0);
            }
         },
    'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.setMethodImplForInt8Array' : (obj, index, value) => { obj[index] = value; },
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
    'org.khronos.webgl.byteLength_$external_prop_getter_1' : (_this) => _this.byteLength,
    'org.khronos.webgl.Int8Array_$external_fun' : (p0) => new Int8Array(p0),
    'org.khronos.webgl.Int8Array_$external_fun_1' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter_1' : (_this) => _this.buffer,
    'org.khronos.webgl.getParameter_$external_fun' : (_this, p0) => _this.getParameter(p0),
    'org.khronos.webgl.SAMPLES_$external_prop_getter' : (_this) => _this.SAMPLES,
    'org.khronos.webgl.Companion_$external_object_getInstance' : () => WebGLRenderingContext,
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
    'org.w3c.dom.css.fontSize_$external_prop_getter' : (_this) => _this.fontSize,
    'org.w3c.dom.css.fontSize_$external_prop_setter' : (_this, v) => _this.fontSize = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.deltaMode_$external_prop_getter' : (_this) => _this.deltaMode,
    'org.w3c.dom.events.DOM_DELTA_PIXEL_$external_prop_getter' : (_this) => _this.DOM_DELTA_PIXEL,
    'org.w3c.dom.events.DOM_DELTA_LINE_$external_prop_getter' : (_this) => _this.DOM_DELTA_LINE,
    'org.w3c.dom.events.DOM_DELTA_PAGE_$external_prop_getter' : (_this) => _this.DOM_DELTA_PAGE,
    'org.w3c.dom.events.Companion_$external_object_getInstance' : () => WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.history_$external_prop_getter' : (_this) => _this.history,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.innerWidth_$external_prop_getter' : (_this) => _this.innerWidth,
    'org.w3c.dom.innerHeight_$external_prop_getter' : (_this) => _this.innerHeight,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.getComputedStyle_$external_fun' : (_this, p0, p1, isDefault0) => _this.getComputedStyle(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.removeListener_$external_fun' : (_this, p0) => _this.removeListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.href_$external_prop_getter' : (_this) => _this.href,
    'org.w3c.dom.origin_$external_prop_getter' : (_this) => _this.origin,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.hostname_$external_prop_getter' : (_this) => _this.hostname,
    'org.w3c.dom.pathname_$external_prop_getter' : (_this) => _this.pathname,
    'org.w3c.dom.search_$external_prop_getter' : (_this) => _this.search,
    'org.w3c.dom.hash_$external_prop_getter' : (_this) => _this.hash,
    'org.w3c.dom.hash_$external_prop_setter' : (_this, v) => _this.hash = v,
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.location_$external_prop_getter_1' : (_this) => _this.location,
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.title_$external_prop_setter' : (_this, v) => _this.title = v,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.createTextNode_$external_fun' : (_this, p0) => _this.createTextNode(p0),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.classList_$external_prop_getter' : (_this) => _this.classList,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.scrollTop_$external_prop_getter' : (_this) => _this.scrollTop,
    'org.w3c.dom.scrollTop_$external_prop_setter' : (_this, v) => _this.scrollTop = v,
    'org.w3c.dom.scrollLeft_$external_prop_getter' : (_this) => _this.scrollLeft,
    'org.w3c.dom.scrollLeft_$external_prop_setter' : (_this, v) => _this.scrollLeft = v,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.removeAttribute_$external_fun' : (_this, p0) => _this.removeAttribute(p0),
    'org.w3c.dom.hasAttribute_$external_fun' : (_this, p0) => _this.hasAttribute(p0),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.parentElement_$external_prop_getter' : (_this) => _this.parentElement,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.nextSibling_$external_prop_getter' : (_this) => _this.nextSibling,
    'org.w3c.dom.textContent_$external_prop_getter' : (_this) => _this.textContent,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.insertBefore_$external_fun' : (_this, p0, p1) => _this.insertBefore(p0, p1),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.add_$external_fun' : (_this, p0) => _this.add(...p0),
    'org.w3c.dom.readyState_$external_prop_getter_1' : (_this) => _this.readyState,
    'org.w3c.dom.protocol_$external_prop_getter_1' : (_this) => _this.protocol,
    'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
    'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.OPEN_$external_prop_getter' : (_this) => _this.OPEN,
    'org.w3c.dom.Companion_$external_object_getInstance' : () => WebSocket,
    'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.MessageEvent_$external_class_instanceof' : (x) => x instanceof MessageEvent,
    'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.Worker_$external_fun' : (p0, p1, isDefault0) => new Worker(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.postMessage_$external_fun' : (_this, p0, p1, isDefault0) => _this.postMessage(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.Worker_$external_class_instanceof' : (x) => x instanceof Worker,
    'org.w3c.dom.Worker_$external_class_get' : () => Worker,
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.state_$external_prop_getter' : (_this) => _this.state,
    'org.w3c.dom.back_$external_fun' : (_this, ) => _this.back(),
    'org.w3c.dom.pushState_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.pushState(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.replaceState_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.replaceState(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.children_$external_prop_getter' : (_this) => _this.children,
    'org.w3c.dom.firstElementChild_$external_prop_getter' : (_this) => _this.firstElementChild,
    'org.w3c.dom.lastElementChild_$external_prop_getter' : (_this) => _this.lastElementChild,
    'org.w3c.dom.Companion_$external_object_getInstance_2' : () => ({}),
    'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.right_$external_prop_getter' : (_this) => _this.right,
    'org.w3c.dom.bottom_$external_prop_getter' : (_this) => _this.bottom,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.nextElementSibling_$external_prop_getter' : (_this) => _this.nextElementSibling,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.Companion_$external_object_getInstance_3' : () => ({}),
    'org.w3c.dom.removeItem_$external_fun' : (_this, p0) => _this.removeItem(p0),
    'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
    'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_instanceof' : (x) => x instanceof PointerEvent,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_get' : () => PointerEvent,
    'org.w3c.dom.url.createObjectURL_$external_fun' : (_this, p0) => _this.createObjectURL(p0),
    'org.w3c.dom.url.revokeObjectURL_$external_fun' : (_this, p0) => _this.revokeObjectURL(p0),
    'org.w3c.dom.url.Companion_$external_object_getInstance' : () => URL,
    'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
    'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
    'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.arrayBuffer_$external_fun' : (_this, ) => _this.arrayBuffer(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.fetch.Response_$external_class_instanceof' : (x) => x instanceof Response,
    'org.w3c.fetch.Response_$external_class_get' : () => Response,
    'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
    'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
    'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
    'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
    'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
    'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
    'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
        try {
            body();
            return null;
        } catch(e) {
            return e;
        }
    },
    'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
    'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
    'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
    'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
    'kotlinx.io.getPlatformName' : 
        () => (typeof navigator !== "undefined" && navigator.platform) || "unknown"
    ,
    'kotlinx.io.node.loadBuffer' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:buffer') : null),
    'kotlinx.io.node.loadOs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:os') : null),
    'kotlinx.io.node.loadPath' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:path') : null),
    'kotlinx.io.node.loadFs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:fs') : null),
    'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
    'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
    'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.date.Date_$external_fun' : () => new Date(),
    'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
    'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
    'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
    'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
    'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
    'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
    'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
    'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
    'io.ktor.util.hasNodeApi' : () => 
    (typeof process !== 'undefined' 
        && process.versions != null 
        && process.versions.node != null) ||
    (typeof window !== 'undefined' 
        && typeof window.process !== 'undefined' 
        && window.process.versions != null 
        && window.process.versions.node != null)
    ,
    'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
    'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
    'io.ktor.util.logging.console_$external_prop_getter' : () => console,
    'io.ktor.http.locationOrigin' : () => function() {
        var tmpLocation = null
        if (typeof window !== 'undefined') {
          tmpLocation = window.location
        } else if (typeof self !== 'undefined') {
          tmpLocation = self.location
        }
        var origin = ""
        if (tmpLocation) {
          origin = tmpLocation.origin
        }
        return origin && origin != "null" ? origin : "http://localhost"    
    }(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skia.webext.skikoArrayBuffer' : (skikoWasm) => skikoWasm.wasmExports.memory.buffer,
    'org.jetbrains.skia.webext.copyBuffer' : (src, dst, dstOffset) => { 
            var dstView = new Uint8Array(dst);
            var srcView = new Uint8Array(src);
            dstView.set(srcView, dstOffset);
         },
    'org.jetbrains.skiko.currentNanoTimeWindowPerformance' : () => window.performance.now() * 1000000,
    'org.jetbrains.skiko.currentGLContext' : (gl) => gl.currentContext ? gl.currentContext.GLctx : null,
    'org.jetbrains.skiko.windowRequestAnimationFrame' : (callback) => window.requestAnimationFrame(callback),
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'org.jetbrains.skiko.defaultFetchInit_js_code' : () => ({}),
    'org.jetbrains.skiko.jsCatch' : function (f) { try { f(); } catch (e) { return e;}; return null; },
    'org.jetbrains.skiko.jsThrow' : (e) => { throw e; },
    'org.jetbrains.skiko.wasm.patchWebGlContext' : (canvas) => {
        if (!canvas.getContext.webGlContextPatched) {
            var oldGetContext = canvas.getContext;
            canvas.getContext = function() {
                var gl = oldGetContext.apply(this, arguments);
                if (gl && !gl.webGlContextPatched) {
                    var oldGetSupportedExtensions = gl.getSupportedExtensions;
                    if (typeof oldGetSupportedExtensions === 'function') {
                        gl.getSupportedExtensions = function() {
                            var exts = oldGetSupportedExtensions.apply(this, arguments);
                            if (exts && exts.filter) {
                                return exts.filter(function(name) {
                                    return name !== 'WEBGL_debug_renderer_info' && name !== 'WEBGL_polygon_mode';
                                });
                            }
                            return exts;
                        };
                    }
                    var oldGetExtension = gl.getExtension;
                    if (typeof oldGetExtension === 'function') {
                        gl.getExtension = function(name) {
                            if (name === 'WEBGL_debug_renderer_info' || name === 'WEBGL_polygon_mode') {
                                return null;
                            }
                            return oldGetExtension.apply(this, arguments);
                        };
                    }
                    var oldGetParameter = gl.getParameter;
                    if (typeof oldGetParameter === 'function') {
                        gl.getParameter = function(pname) {
                            // 0x9245 = UNMASKED_VENDOR_WEBGL, 0x9246 = UNMASKED_RENDERER_WEBGL;
                            // both belong to WEBGL_debug_renderer_info, so hide them to avoid the INVALID_ENUM warning
                            if (pname === 0x9245 || pname === 0x9246) {
                                return "";
                            }
                            // 0x0C02 = READ_BUFFER;
                            // hide to avoid "The READ_BUFFER attachment is multisampled" warning in Firefox
                            if (pname === 0x0C02) {
                                var fbo = oldGetParameter.apply(this, [0x8CAA]); // 0x8CAA = READ_FRAMEBUFFER_BINDING
                                return fbo ? 0x8CE0 : 0x0405; // 0x8CE0 = COLOR_ATTACHMENT0, 0x0405 = BACK
                            }
                            return oldGetParameter.apply(this, arguments);
                        };
                    }
                    gl.webGlContextPatched = true;
                }
                return gl;
            };
            canvas.getContext.webGlContextPatched = true;
        }
    },
    'org.jetbrains.skiko.wasm.contextAttributesWithDefaults' : (attr) => ({
            alpha: attr && attr.alpha != null ? attr.alpha : 1,
            depth: attr && attr.depth != null ? attr.depth : 1,
            stencil: attr && attr.stencil != null ? attr.stencil : 8,
            antialias: attr && attr.antialias != null ? attr.antialias : 0,
            premultipliedAlpha: attr && attr.premultipliedAlpha != null ? attr.premultipliedAlpha : 1,
            preserveDrawingBuffer: attr && attr.preserveDrawingBuffer != null ? attr.preserveDrawingBuffer : 0,
            powerPreference: ['default', 'low-power', 'high-performance'][
                attr && attr.powerPreference != null ? attr.powerPreference : 0
            ],
            failIfMajorPerformanceCaveat: attr && attr.failIfMajorPerformanceCaveat != null ? attr.failIfMajorPerformanceCaveat : 0,
            majorVersion: attr && attr.majorVersion != null ? attr.majorVersion : 2,
            enableExtensionsByDefault: attr && attr.enableExtensionsByDefault != null ? attr.enableExtensionsByDefault : 1,
            explicitSwapControl: attr && attr.explicitSwapControl != null ? attr.explicitSwapControl : 0,
            renderViaOffscreenBackBuffer: attr && attr.renderViaOffscreenBackBuffer != null ? attr.renderViaOffscreenBackBuffer : 0,
            desynchronized: attr && attr.desynchronized != null ? attr.desynchronized : 0,
        }),
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl.addLanguageChangeListener' : (listener) => { window.addEventListener('languagechange', listener) },
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._script_$external_prop_getter' : (_this) => _this.script,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun_1' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun_1' : (_this, ) => _this.deref(),
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.events.abort_$external_fun' : (_this, ) => _this.abort(),
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isVibrationSupported' : () => 
            typeof window !== 'undefined' &&
            window.navigator != null &&
            typeof window.navigator.vibrate === 'function'
        ,
    'androidx.compose.ui.platform.vibrate' : (pattern) => { window.navigator.vibrate(pattern) },
    'androidx.compose.ui.platform.getSelectionRange' : (element) => {
            var selection = window.getSelection();
            if (selection == null) return null;
            var root = element.getRootNode();
            if (root == null) return null;

            if (typeof selection.getComposedRanges === 'function') {
                try {
                    // The modern standard approach
                    var composedRanges = selection.getComposedRanges({ shadowRoots: [root] });
                    if (composedRanges.length > 0) {
                        return composedRanges[0];
                    }
                    return null;
                } catch (e) {
                    // Fallback for early Safari 17 point-releases
                    var composedRanges = selection.getComposedRanges(root);
                    if (composedRanges.length > 0) {
                        return composedRanges[0];
                    }
                    return null;
                }
            }

            if (typeof root.getSelection === 'function') {
                var rootSelection = root.getSelection();
                if (rootSelection == null) return [0, 0];
                if (rootSelection.rangeCount > 0) {
                    return rootSelection.getRangeAt(0);
                }
                return null;
            }

            if (selection.rangeCount > 0) {
                return selection.getRangeAt(0);
            }
            return null;
        },
    'androidx.compose.ui.platform.computeSelectionOffset' : (container, offset) => {          
        // container.nodeType stands for textNodes                   
        if (container.nodeType == 3) return offset;
        var chars = 0;
        var n = Math.min(offset, container.childNodes.length);
        for (var i = 0; i < n; i++) {
            var c = container.childNodes[i];
            chars += (c.nodeType == 3)
                ? c.nodeValue.length
                : ((c.textContent && c.textContent.length) || 0);
        }
        return chars;
        },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.firstRange_$external_prop_getter' : (_this) => _this.firstRange,
    'androidx.compose.ui.platform.firstRange_$external_prop_setter' : (_this, v) => _this.firstRange = v,
    'androidx.compose.ui.platform.getTargetRanges_$external_fun' : (_this, ) => _this.getTargetRanges(),
    'androidx.compose.ui.platform.startContainer_$external_prop_getter' : (_this) => _this.startContainer,
    'androidx.compose.ui.platform.startOffset_$external_prop_getter' : (_this) => _this.startOffset,
    'androidx.compose.ui.platform.endContainer_$external_prop_getter' : (_this) => _this.endContainer,
    'androidx.compose.ui.platform.endOffset_$external_prop_getter' : (_this) => _this.endOffset,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.setBaseAndExtent_$external_fun' : (_this, p0, p1, p2, p3) => _this.setBaseAndExtent(p0, p1, p2, p3),
    'androidx.compose.ui.platform.getSelection_$external_fun' : (_this, ) => _this.getSelection(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.isSchedulerApiSupported' : () => Boolean('scheduler' in window),
    'androidx.compose.ui.platform.schedulerPostTask' : (block) => scheduler.postTask(block, { priority: 'user-blocking',}),
    'androidx.compose.ui.platform.isIdleApiSupported' : () => Boolean('requestIdleCallback' in window),
    'androidx.compose.ui.platform.requestIdleCallback' : (callback) => window.requestIdleCallback(callback),
    'androidx.compose.ui.platform.cancelIdleCallback' : (handle) => { window.cancelIdleCallback(handle) },
    'androidx.compose.ui.platform.timeRemaining_$external_fun' : (_this, ) => _this.timeRemaining(),
    'androidx.compose.ui.platform.didTimeout_$external_prop_getter' : (_this) => _this.didTimeout,
    'androidx.compose.ui.platform.isFullWakeLockApiSupported' : () => Boolean(
            window.navigator.wakeLock && 
            typeof(WakeLockSentinel) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.hasVirtualKeyboard' : () => ('virtualKeyboard' in navigator),
    'androidx.compose.ui.platform.installSafeAreaCssProperties' : () => (function() {
            let s = document.documentElement.style;
            s.setProperty('--cmp-safe-top', 'env(safe-area-inset-top, 0px)');
            s.setProperty('--cmp-safe-right', 'env(safe-area-inset-right, 0px)');
            s.setProperty('--cmp-safe-bottom', 'env(safe-area-inset-bottom, 0px)');
            s.setProperty('--cmp-safe-left', 'env(safe-area-inset-left, 0px)');
        })(),
    'androidx.compose.ui.platform.enableVirtualKeyboardOverlay' : () => (navigator.virtualKeyboard.overlaysContent = true),
    'androidx.compose.ui.platform.getVirtualKeyboard' : () => navigator.virtualKeyboard,
    'androidx.compose.ui.platform.getVisualViewport' : () => (window.visualViewport || null),
    'androidx.compose.ui.platform.readCssVarLeft' : () => (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cmp-safe-left')) || 0),
    'androidx.compose.ui.platform.readCssVarTop' : () => (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cmp-safe-top')) || 0),
    'androidx.compose.ui.platform.readCssVarRight' : () => (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cmp-safe-right')) || 0),
    'androidx.compose.ui.platform.readCssVarBottom' : () => (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cmp-safe-bottom')) || 0),
    'androidx.compose.ui.platform.readVirtualKeyboardHeight' : () => (navigator.virtualKeyboard.boundingRect.height || 0),
    'androidx.compose.ui.platform.readVisualViewportImeHeight' : () => (function() {
        let vv = window.visualViewport;
        if (!vv) return 0;
        return Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
    })(),
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                case 11: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/dialog_role
                    roleValue = "dialog";
                    break;
                case 12: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/link_role
                    roleValue = "link";
                    break;
                case 13: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/progressbar_role
                    roleValue = "progressbar";
                    break;
                case 14: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/slider_role
                    roleValue = "slider";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           const leftValue = "" + left + "px";
           const topValue = "" + top + "px";
           const widthValue = "" + width + "px";
           const heightValue = "" + height + "px";

           if (element.style.left !== leftValue) {
               element.style.left = leftValue;
           }
           if (element.style.top !== topValue) {
               element.style.top = topValue;
           }
           if (element.style.width !== widthValue) {
               element.style.width = widthValue;
           }
           if (element.style.height !== heightValue) {
               element.style.height = heightValue;
           }
         },
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.toggleAttribute_$external_fun' : (_this, p0, p1) => _this.toggleAttribute(p0, p1),
    'androidx.compose.ui.platform.accessibility.setScrollContainerStyle' : (element, horizontal, vertical) => { 
            element.style.overflowX = horizontal ? "scroll" : "hidden";
            element.style.overflowY = vertical ? "scroll" : "hidden";
            element.style.scrollbarWidth = "none";
             },
    'androidx.compose.ui.platform.accessibility.resetScrollContainerStyle' : (element) => { 
            element.style.overflowX = "";
            element.style.overflowY = "";
            element.style.scrollbarWidth = "";
             },
    'androidx.compose.ui.window.clearNodeChildren' : (node) => 
            {
                if (node.hasChildNodes()) node.replaceChildren();
            }
        ,
    'androidx.compose.ui.window.isWebGL2Supported' : () => !!document.createElement('canvas').getContext('webgl2'),
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.checkViewportFitCover' : () => (function() {
            let meta = document.querySelector('meta[name=viewport]');
            let content = meta ? (meta.getAttribute('content') || '') : '';
            if (!content.includes('viewport-fit=cover')) {
                console.warn(
                    "[ComposeWeb] enableBrowserWindowInsets is set to true, but " +
                    "'viewport-fit=cover' is not found in the viewport meta tag. " +
                    "Safe area insets will be zero. Add viewport-fit=cover to your viewport meta tag: " +
                    "<meta name=\"viewport\" content=\"width=device-width, initial-scale=1, viewport-fit=cover\">"
                );
            }
        })(),
    'androidx.compose.ui.window.getVisualViewportScale' : () => window.visualViewport.scale,
    'androidx.compose.ui.window.isTouchEvent' : (event) => event.pointerType === 'touch',
    'androidx.compose.ui.window.releasePointerCapture' : (target, pointerId) => { try { target.releasePointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.composeComponentElementCtor' : (weakMap) => 
        (() => {
            class ComposeComponentElement extends HTMLElement {
                disconnectedCallback() {
                    const cb = weakMap.get(this);
                    if (cb) cb();
                }
            }
            return ComposeComponentElement;
        })()
    ,
    'androidx.compose.ui.window.clientXOf' : (event) => event.clientX,
    'androidx.compose.ui.window.clientYOf' : (event) => event.clientY,
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.getVisualViewport' : () => window.visualViewport,
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.WeakMap_$external_fun' : () => new WeakMap(),
    'androidx.compose.ui.window.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.window.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'androidx.compose.ui.window.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.window.define_$external_fun' : (_this, p0, p1) => _this.define(p0, p1),
    'androidx.compose.ui.window.customElements_$external_prop_getter' : () => customElements,
    'androidx.compose.ui.window.ResizeObserver_$external_fun' : (p0) => new ResizeObserver(p0),
    'androidx.compose.ui.window.observe_$external_fun' : (_this, p0) => _this.observe(p0),
    'androidx.compose.ui.window.disconnect_$external_fun' : (_this, ) => _this.disconnect(),
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
    'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
    'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
    'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
    'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
    'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
    'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
    'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
    'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
    'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
    'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
    'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
    'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
    'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
    'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
    'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
    'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
    'io.ktor.client.utils.makeJsObject' : () => { return {}; },
    'io.ktor.client.utils.makeImport' : (name) => import(name),
    'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
    'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
    'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
    'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
    'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
    'io.ktor.client.utils.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
    'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
    'pl.animap.web.http.downloadAdminFileRaw' : (url, fileName, authorizationHeader, onDone) => 
        {
          const headers = {};
          if (authorizationHeader != null) {
            headers['Authorization'] = authorizationHeader;
          }
          fetch(url, { method: 'GET', headers: headers, credentials: 'same-origin' })
            .then(async response => {
              if (!response.ok) {
                const contentType = response.headers.get('Content-Type');
                const text = await response.text();
                onDone(false, response.status, contentType, text);
                return;
              }
              const blob = await response.blob();
              const objectUrl = URL.createObjectURL(blob);
              const anchor = document.createElement('a');
              anchor.href = objectUrl;
              anchor.download = fileName;
              document.body.appendChild(anchor);
              anchor.click();
              document.body.removeChild(anchor);
              setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
              onDone(true, response.status, null, '');
            })
            .catch(error => onDone(false, 0, null, String(error)));
        }
    ,
    'pl.animap.web.http.__convertKotlinClosureToJsClosure_4' : (f, trampoline) => getCachedJsObject(f, (p0, p1, p2, p3) => trampoline(f, p0, p1, p2, p3)),
    'pl.animap.web.http.downloadAdminFileFromJsonRequestRaw' : (url, requestBody, fileName, authorizationHeader, onDone) => 
        {
          const headers = { 'Content-Type': 'application/json' };
          if (authorizationHeader != null) {
            headers['Authorization'] = authorizationHeader;
          }
          fetch(url, { method: 'POST', headers: headers, body: requestBody, credentials: 'same-origin' })
            .then(async response => {
              if (!response.ok) {
                const contentType = response.headers.get('Content-Type');
                const text = await response.text();
                onDone(false, response.status, contentType, text);
                return;
              }
              const blob = await response.blob();
              const objectUrl = URL.createObjectURL(blob);
              const anchor = document.createElement('a');
              anchor.href = objectUrl;
              anchor.download = fileName;
              document.body.appendChild(anchor);
              anchor.click();
              document.body.removeChild(anchor);
              setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
              onDone(true, response.status, null, '');
            })
            .catch(error => onDone(false, 0, null, String(error)));
        }
    ,
    'pl.animap.web.http.uploadPickedFileRaw' : (url, partName, fileId, authorizationHeader, onDone) => 
        {
          const store = window.__animapAdminUploads;
          const entry = store && store.get(fileId);
          if (!entry || !entry.file) {
            onDone(0, null, '');
          } else {
            const formData = new FormData();
            formData.append(partName, entry.file, entry.file.name);
            const headers = {};
            if (authorizationHeader != null) {
              headers['Authorization'] = authorizationHeader;
            }
            fetch(url, { method: 'POST', body: formData, headers: headers, credentials: 'same-origin' })
              .then(async response => {
                const body = await response.text();
                onDone(response.status, response.headers.get('Content-Type'), body);
              })
              .catch(() => onDone(0, null, ''));
          }
        }
        ,
    'pl.animap.web.http.__convertKotlinClosureToJsClosure_3' : (f, trampoline) => getCachedJsObject(f, (p0, p1, p2) => trampoline(f, p0, p1, p2)),
    'pl.animap.web.http.releasePickedFileRaw' : (fileId) => 
        {
          const store = window.__animapAdminUploads;
          const entry = store && store.get(fileId);
          if (entry) {
            if (entry.previewUrl) URL.revokeObjectURL(entry.previewUrl);
            store.delete(fileId);
          }
        }
        ,
    'pl.animap.web.http.pickAdminFilesRaw' : (accept, supportedContentTypes, untypedExtensions, untypedContentTypes, onFile, onDone) => 
        {
          const supported = supportedContentTypes.split(',');
          const extensions = untypedExtensions.length > 0 ? untypedExtensions.split(',') : [];
          const extensionTypes = untypedContentTypes.split(',');
          const resolvedType = (file) => {
            if (file.type) return file.type;
            const name = file.name.toLowerCase();
            const index = extensions.findIndex((extension) => name.endsWith(extension));
            return index >= 0 ? extensionTypes[index] : '';
          };
          const input = document.createElement('input');
          input.type = 'file';
          input.multiple = true;
          input.accept = accept;
          input.style.position = 'fixed';
          input.style.left = '-10000px';
          input.style.top = '0';
          input.style.width = '1px';
          input.style.height = '1px';
          input.style.opacity = '0';
          document.body.appendChild(input);
          let completed = false;
          const cleanup = () => {
            if (input.parentNode) input.parentNode.removeChild(input);
          };
          input.onchange = () => {
            if (completed) return;
            completed = true;
            const files = input.files ? Array.from(input.files) : [];
            cleanup();
            if (files.length === 0) {
              onDone(0, true, false);
              return;
            }
            const valid = files.filter((file) => supported.includes(resolvedType(file)));
            if (valid.length === 0) {
              onDone(files.length, false, true);
              return;
            }
            const store = window.__animapAdminUploads || (window.__animapAdminUploads = new Map());
            valid.forEach((file) => {
              const id = 'upload-' + Math.random().toString(36).slice(2) + '-' + Date.now();
              const type = resolvedType(file);
              const typed = type === file.type ? file : new File([file], file.name, { type: type });
              const previewUrl = URL.createObjectURL(typed);
              store.set(id, { file: typed, previewUrl: previewUrl });
              onFile(id, file.name, type, file.size, previewUrl);
            });
            onDone(files.length - valid.length, false, false);
          };
          input.oncancel = () => {
            if (completed) return;
            completed = true;
            cleanup();
            onDone(0, true, false);
          };
          input.click();
        }
        ,
    'pl.animap.web.http.__convertKotlinClosureToJsClosure_5' : (f, trampoline) => getCachedJsObject(f, (p0, p1, p2, p3, p4) => trampoline(f, p0, p1, p2, p3, p4)),
    'pl.animap.web.http.readPickedFileBytesRaw' : (fileId, onDone) => 
        {
          const store = window.__animapAdminUploads;
          const entry = store && store.get(fileId);
          if (!entry || !entry.file) {
            onDone(false, '');
          } else {
            entry.file.arrayBuffer()
              .then((buffer) => {
                const bytes = new Uint8Array(buffer);
                const chunks = [];
                for (let start = 0; start < bytes.length; start += 0x8000) {
                  chunks.push(String.fromCharCode.apply(null, bytes.subarray(start, start + 0x8000)));
                }
                onDone(true, chunks.join(''));
              })
              .catch(() => onDone(false, ''));
          }
        }
        ,
    'pl.animap.web.http.__convertKotlinClosureToJsClosure_2' : (f, trampoline) => getCachedJsObject(f, (p0, p1) => trampoline(f, p0, p1)),
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'androidx.compose.foundation.gestures.legacyWheelDeltaX' : (event) => (event.wheelDeltaX == null) ? NaN : event.wheelDeltaX,
    'androidx.compose.foundation.gestures.legacyWheelDeltaY' : (event) => (event.wheelDeltaY == null) ? NaN : event.wheelDeltaY,
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'coil3.decode.blob' : (code) => new Blob([code], { type: 'application/javascript' }),
    'coil3.decode.WebWorkerRequest' : (id, buffer, width, height) => ({ id: id, data: buffer, w: width, h: height }),
    'coil3.decode.id_$external_prop_getter' : (_this) => _this.id,
    'coil3.decode.kind_$external_prop_getter' : (_this) => _this.kind,
    'coil3.decode.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'coil3.decode.message_$external_prop_getter' : (_this) => _this.message,
    'coil3.fetch.fetch' : (url) => fetch(url),
    'coil3.util.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'coil3.util.deref_$external_fun' : (_this, ) => _this.deref(),
    'pl.animap.ui.design.internal.browserAbsoluteUrl' : (path) => new URL(path, window.location.href).href,
    'pl.animap.ui.design.internal.setHtmlOverlayLayerHidden' : (hidden) => 
        {
            const layer = document.getElementById('components');
            if (layer) layer.style.visibility = hidden ? 'hidden' : 'visible';
        }
        ,
    'pl.animap.ui.design.molecules.stopAppAudioPreview' : () => 
        {
          const audio = window.__animapAudioPreview;
          if (audio) {
            audio.onended = null;
            audio.onerror = null;
            audio.pause();
            window.__animapAudioPreview = null;
          }
        }
        ,
    'pl.animap.ui.design.molecules.playAppAudioPreview' : (src, onEnded) => 
        {
          const previous = window.__animapAudioPreview;
          if (previous) {
            previous.onended = null;
            previous.onerror = null;
            previous.pause();
          }
          const audio = new Audio(src);
          audio.onended = onEnded;
          audio.onerror = onEnded;
          window.__animapAudioPreview = audio;
          const started = audio.play();
          if (started && started.catch) started.catch(() => onEnded());
        }
        ,
    'pl.animap.ui.design.molecules.openSystemColorPickerAt' : (currentHex, leftCssPx, topCssPx, widthCssPx, heightCssPx, onPicked) => 
        {
          const anchored = widthCssPx > 0 && heightCssPx > 0;
          const left = anchored ? leftCssPx : (window.innerWidth / 2);
          const top = anchored ? topCssPx : (window.innerHeight / 2);
          const input = document.createElement('input');
          input.type = 'color';
          input.value = currentHex;
          input.style.position = 'fixed';
          input.style.left = left + 'px';
          input.style.top = top + 'px';
          input.style.width = (anchored ? widthCssPx : 1) + 'px';
          input.style.height = (anchored ? heightCssPx : 1) + 'px';
          input.style.margin = '0';
          input.style.padding = '0';
          input.style.border = 'none';
          input.style.opacity = '0';
          input.style.pointerEvents = 'none';
          document.body.appendChild(input);
          let done = false;
          const cleanup = () => {
            if (done) return;
            done = true;
            if (input.parentNode) input.parentNode.removeChild(input);
          };
          input.addEventListener('input', () => onPicked(input.value));
          input.addEventListener('change', () => {
            const value = input.value;
            cleanup();
            onPicked(value);
          });
          input.addEventListener('blur', cleanup);
          if (input.showPicker) {
            input.showPicker();
          } else {
            input.click();
          }
        }
        ,
    'pl.animap.ui.design.molecules.showAppMediaLightbox' : (src, isVideo, dialogName, mediaAlternative, closeName, onClose) => 
        {
          const existing = document.getElementById('app-media-lightbox');
          if (existing && existing.__release) existing.__release();

          const previouslyFocused = document.activeElement;
          const overlay = document.createElement('div');
          overlay.id = 'app-media-lightbox';
          overlay.setAttribute('role', 'dialog');
          overlay.setAttribute('aria-modal', 'true');
          overlay.setAttribute('aria-label', dialogName);
          overlay.style.cssText =
            'position:fixed;inset:0;z-index:5000;background:rgba(0,0,0,0.82);' +
            'display:flex;align-items:center;justify-content:center;padding:32px;box-sizing:border-box;';

          const style = document.createElement('style');
          style.textContent =
            '#app-media-lightbox button:focus-visible,#app-media-lightbox video:focus-visible' +
            '{outline:3px solid #fff;outline-offset:2px;}';
          overlay.appendChild(style);

          const inertedSiblings = [];
          const makeInert = (child) => {
            if (child !== overlay && !child.inert) {
              child.inert = true;
              inertedSiblings.push(child);
            }
          };
          Array.from(document.body.children).forEach(makeInert);
          const lateSiblings = new MutationObserver((records) => {
            records.forEach((record) => record.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) makeInert(node);
            }));
          });
          lateSiblings.observe(document.body, { childList: true });

          let released = false;
          const release = () => {
            if (released) return;
            released = true;
            document.removeEventListener('keydown', onKey, true);
            lateSiblings.disconnect();
            if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
            inertedSiblings.forEach((child) => { child.inert = false; });
            if (previouslyFocused && previouslyFocused.isConnected && previouslyFocused.focus) {
              previouslyFocused.focus();
            }
          };
          overlay.__release = release;
          const close = () => {
            release();
            onClose();
          };

          const media = document.createElement(isVideo ? 'video' : 'img');
          media.style.cssText =
            'max-width:90vw;max-height:85vh;border-radius:12px;' +
            'box-shadow:0 12px 48px rgba(0,0,0,0.45);background:#000;';
          if (isVideo) {
            media.controls = true;
            media.playsInline = true;
            media.autoplay = false;
            media.preload = 'metadata';
            media.setAttribute('aria-label', mediaAlternative);
            media.src = src || '';
          } else {
            media.alt = mediaAlternative;
            media.src = src || '';
          }

          const closeButton = document.createElement('button');
          closeButton.type = 'button';
          closeButton.setAttribute('aria-label', closeName);
          closeButton.textContent = '✕';
          closeButton.style.cssText =
            'position:absolute;top:20px;right:24px;width:40px;height:40px;border-radius:50%;border:0;padding:0;' +
            'background:rgba(255,255,255,0.16);color:#fff;display:flex;align-items:center;' +
            'justify-content:center;font:700 18px system-ui,-apple-system,BlinkMacSystemFont,sans-serif;' +
            'cursor:pointer;';
          closeButton.onclick = close;

          const focusGuard = (target) => {
            const guard = document.createElement('span');
            guard.tabIndex = 0;
            guard.setAttribute('aria-hidden', 'true');
            guard.dataset.lightboxGuard = 'true';
            guard.onfocus = () => target().focus();
            return guard;
          };
          const forward = isVideo ? media : closeButton;
          const tabOrder = isVideo ? [closeButton, media] : [closeButton];
          const first = tabOrder[0];
          const last = tabOrder[tabOrder.length - 1];

          const onKey = (event) => {
            if (event.key === 'Escape') {
              event.preventDefault();
              event.stopPropagation();
              close();
              return;
            }
            if (event.key !== 'Tab') return;
            const active = document.activeElement;
            if (event.shiftKey && active === first) {
              event.preventDefault();
              event.stopPropagation();
              last.focus();
            } else if (!event.shiftKey && active === last && !isVideo) {
              event.preventDefault();
              event.stopPropagation();
              first.focus();
            } else if (!overlay.contains(active)) {
              event.preventDefault();
              event.stopPropagation();
              (event.shiftKey ? last : first).focus();
            }
          };

          overlay.onclick = (event) => { if (event.target === overlay) close(); };
          document.addEventListener('keydown', onKey, true);

          overlay.appendChild(focusGuard(() => last));
          overlay.appendChild(closeButton);
          overlay.appendChild(media);
          overlay.appendChild(focusGuard(() => first));
          document.body.appendChild(overlay);
          closeButton.focus();
          return overlay;
        }
        ,
    'pl.animap.ui.design.molecules.hideAppMediaLightbox' : (overlay) => overlay.__release(),
    'pl.animap.ui.design.molecules.downloadFile' : (url, fileName) => 
        {
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.rel = 'noopener';
            document.body.appendChild(a);
            a.click();
            a.remove();
        }
    ,
    'pl.animap.ui.design.molecules.browserEpochMillis' : () => Date.now(),
    'pl.animap.maps.web.internal.js.removeOpenEditorLeafletPointPicker' : () => 
        {
          const picker = document.getElementById('animap-leaflet-picker');
          if (picker && picker.removePicker) {
            picker.removePicker();
          } else if (picker) {
            picker.remove();
          }
        }
        ,
    'pl.animap.maps.web.internal.js.openEditorLeafletPointPicker' : (lat, lng, zoom, markersJson, searchPlaceholder, searchButtonLabel, searchInputLabel, dialogTitle, closeLabel, mapLabel, searchBarDividerColor, searchInputBorderColor, searchStatusTextColor, primaryColor, onPrimaryColor, accentColor, onAccentColor, onPointSelected, onClosed, onSearchRequested) => 
        {
          const previous = document.getElementById('animap-leaflet-picker');
          if (previous && previous.removePicker) previous.removePicker();

          const overlay = document.createElement('div');
          overlay.id = 'animap-leaflet-picker';
          overlay.setAttribute('role', 'dialog');
          overlay.setAttribute('aria-modal', 'true');
          overlay.setAttribute('aria-labelledby', 'animap-leaflet-picker-title');
          const previouslyFocused = document.activeElement;
          overlay.style.position = 'fixed';
          overlay.style.inset = '0';
          overlay.style.zIndex = '2147483000';
          overlay.style.background = 'rgba(15, 33, 24, 0.74)';
          overlay.style.display = 'flex';
          overlay.style.alignItems = 'center';
          overlay.style.justifyContent = 'center';
          overlay.style.padding = '28px';
          overlay.style.boxSizing = 'border-box';

          const panel = document.createElement('div');
          panel.style.width = 'min(1040px, 100%)';
          panel.style.height = 'min(680px, 100%)';
          panel.style.background = '#f8f6ef';
          panel.style.borderRadius = '8px';
          panel.style.boxShadow = '0 24px 80px rgba(0,0,0,0.32)';
          panel.style.overflow = 'hidden';
          panel.style.display = 'flex';
          panel.style.flexDirection = 'column';

          const header = document.createElement('div');
          header.style.display = 'flex';
          header.style.justifyContent = 'space-between';
          header.style.alignItems = 'center';
          header.style.padding = '14px 16px';
          header.style.background = primaryColor;
          header.style.color = onPrimaryColor;
          header.style.font = '600 16px system-ui, -apple-system, BlinkMacSystemFont, sans-serif';

          const title = document.createElement('span');
          title.id = 'animap-leaflet-picker-title';
          title.textContent = dialogTitle;
          header.appendChild(title);

          const close = document.createElement('button');
          close.type = 'button';
          close.id = 'animap-leaflet-picker-close';
          close.textContent = closeLabel;
          close.style.border = '0';
          close.style.borderRadius = '6px';
          close.style.padding = '8px 12px';
          close.style.background = accentColor;
          close.style.color = onAccentColor;
          close.style.font = '600 14px system-ui, -apple-system, BlinkMacSystemFont, sans-serif';
          close.style.cursor = 'pointer';
          header.appendChild(close);

          const searchBar = document.createElement('div');
          searchBar.style.display = 'flex';
          searchBar.style.gap = '8px';
          searchBar.style.padding = '10px 16px';
          searchBar.style.borderBottom = '1px solid ' + searchBarDividerColor;
          searchBar.style.background = '#f8f6ef';

          const searchInput = document.createElement('input');
          searchInput.type = 'text';
          searchInput.id = 'animap-leaflet-picker-search-input';
          searchInput.placeholder = searchPlaceholder;
          searchInput.setAttribute('aria-label', searchInputLabel);
          searchInput.style.flex = '1';
          searchInput.style.padding = '8px 10px';
          searchInput.style.border = '1px solid ' + searchInputBorderColor;
          searchInput.style.borderRadius = '6px';
          searchInput.style.font = '14px system-ui, -apple-system, BlinkMacSystemFont, sans-serif';

          const searchButton = document.createElement('button');
          searchButton.type = 'button';
          searchButton.textContent = searchButtonLabel;
          searchButton.style.border = '0';
          searchButton.style.borderRadius = '6px';
          searchButton.style.padding = '8px 14px';
          searchButton.style.background = primaryColor;
          searchButton.style.color = onPrimaryColor;
          searchButton.style.font = '600 14px system-ui, -apple-system, BlinkMacSystemFont, sans-serif';
          searchButton.style.cursor = 'pointer';

          searchBar.appendChild(searchInput);
          searchBar.appendChild(searchButton);

          const searchStatus = document.createElement('div');
          searchStatus.id = 'animap-leaflet-picker-search-status';
          searchStatus.setAttribute('role', 'status');
          searchStatus.setAttribute('aria-live', 'polite');
          searchStatus.setAttribute('aria-atomic', 'true');
          searchStatus.style.padding = '8px 16px 0 16px';
          searchStatus.style.font = '13px system-ui, -apple-system, BlinkMacSystemFont, sans-serif';
          searchStatus.style.color = searchStatusTextColor;
          searchStatus.style.minHeight = '18px';

          const searchResults = document.createElement('div');
          searchResults.id = 'animap-leaflet-picker-search-results';
          searchResults.style.maxHeight = '160px';
          searchResults.style.overflowY = 'auto';

          const triggerSearch = () => onSearchRequested(searchInput.value);
          searchButton.addEventListener('click', triggerSearch);
          searchInput.addEventListener('keydown', event => {
            if (event.key === 'Enter') {
              event.preventDefault();
              triggerSearch();
            }
          });

          const mapElement = document.createElement('div');
          mapElement.id = 'animap-leaflet-picker-map';
          mapElement.setAttribute('role', 'group');
          mapElement.setAttribute('aria-label', mapLabel);
          mapElement.tabIndex = 0;
          mapElement.style.flex = '1';
          mapElement.style.minHeight = '320px';
          const focusStyle = document.createElement('style');
          focusStyle.textContent =
            '#animap-leaflet-picker button:focus-visible,#animap-leaflet-picker input:focus-visible' +
            '{outline:3px solid ' + onPrimaryColor + ';outline-offset:2px;box-shadow:0 0 0 5px ' + primaryColor + ';}' +
            '#animap-leaflet-picker #animap-leaflet-picker-map:focus-visible' +
            '{outline:3px solid ' + primaryColor + ';outline-offset:-3px;}';
          overlay.appendChild(focusStyle);
          panel.appendChild(header);
          panel.appendChild(searchBar);
          panel.appendChild(searchStatus);
          panel.appendChild(searchResults);
          panel.appendChild(mapElement);
          overlay.appendChild(panel);
          document.body.appendChild(overlay);

          const inertedSiblings = [];
          const makeInert = child => {
            if (child !== overlay && !child.inert) {
              child.inert = true;
              inertedSiblings.push(child);
            }
          };
          Array.from(document.body.children).forEach(makeInert);
          const lateSiblings = new MutationObserver(records => {
            records.forEach(record => record.addedNodes.forEach(node => {
              if (node.nodeType === Node.ELEMENT_NODE) makeInert(node);
            }));
          });
          lateSiblings.observe(document.body, { childList: true });

          const tabbables = () => Array.from(
            overlay.querySelectorAll('button, input, a[href], [tabindex]')
          ).filter(element => element.tabIndex >= 0 && !element.disabled);

          const onKey = event => {
            if (event.key === 'Escape') {
              event.preventDefault();
              event.stopPropagation();
              dismiss();
              return;
            }
            if (event.key !== 'Tab') return;
            const order = tabbables();
            if (order.length === 0) return;
            const first = order[0];
            const last = order[order.length - 1];
            const active = document.activeElement;
            if (!overlay.contains(active)) {
              event.preventDefault();
              (event.shiftKey ? last : first).focus();
            } else if (event.shiftKey && active === first) {
              event.preventDefault();
              last.focus();
            } else if (!event.shiftKey && active === last) {
              event.preventDefault();
              first.focus();
            }
          };
          document.addEventListener('keydown', onKey, true);

          let closed = false;
          let map = null;
          const cleanup = () => {
            if (closed) return;
            closed = true;
            document.removeEventListener('keydown', onKey, true);
            lateSiblings.disconnect();
            inertedSiblings.forEach(child => { child.inert = false; });
            if (map) {
              map.remove();
              map = null;
              overlay.map = null;
            }
            overlay.remove();
            if (previouslyFocused && previouslyFocused.isConnected && previouslyFocused.focus) {
              previouslyFocused.focus();
            }
          };
          overlay.removePicker = cleanup;

          const dismiss = () => {
            cleanup();
            onClosed();
          };
          close.addEventListener('click', dismiss);

          const selectPoint = (selectedLat, selectedLng) => {
            cleanup();
            onPointSelected(selectedLat, selectedLng);
          };
          searchInput.focus();

          if (!window.L) {
            dismiss();
            return;
          }

          map = window.L.map(mapElement, { zoomControl: true }).setView([lat, lng], zoom);
          overlay.map = map;
          window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '© OpenStreetMap contributors',
            maxZoom: 19
          }).addTo(map);

          const markers = JSON.parse(markersJson);
          markers.forEach(marker => {
            window.L.marker([marker.latitude, marker.longitude])
              .bindTooltip(marker.label, { permanent: true, direction: 'top' })
              .addTo(map);
          });
          if (markers.length > 0) {
            const bounds = window.L.latLngBounds(markers.map(marker => [marker.latitude, marker.longitude]));
            map.fitBounds(bounds, { padding: [32, 32], maxZoom: zoom });
          }
          setTimeout(() => map && map.invalidateSize(), 0);
          map.on('click', event => selectPoint(event.latlng.lat, event.latlng.lng));
          mapElement.addEventListener('keydown', event => {
            if (event.key !== 'Enter' || event.target !== mapElement || !map) return;
            event.preventDefault();
            const center = map.getCenter();
            selectPoint(center.lat, center.lng);
          });
        }
        ,
    'pl.animap.maps.web.internal.js.showEditorLeafletPickerSearching' : (message) => 
        {
          const status = document.getElementById('animap-leaflet-picker-search-status');
          const results = document.getElementById('animap-leaflet-picker-search-results');
          if (status) status.textContent = message;
          if (results) results.innerHTML = '';
        }
        ,
    'pl.animap.maps.web.internal.js.showEditorLeafletPickerSearchEmpty' : (message) => 
        {
          const status = document.getElementById('animap-leaflet-picker-search-status');
          const results = document.getElementById('animap-leaflet-picker-search-results');
          if (status) status.textContent = message;
          if (results) results.innerHTML = '';
        }
        ,
    'pl.animap.maps.web.internal.js.showEditorLeafletPickerSearchUnavailable' : (message) => 
        {
          const status = document.getElementById('animap-leaflet-picker-search-status');
          const results = document.getElementById('animap-leaflet-picker-search-results');
          if (status) status.textContent = message;
          if (results) results.innerHTML = '';
        }
        ,
    'pl.animap.maps.web.internal.js.showEditorLeafletPickerSearchResults' : (resultsJson, foundMessage, resultZoom, entryDividerColor) => 
        {
          const picker = document.getElementById('animap-leaflet-picker');
          const status = document.getElementById('animap-leaflet-picker-search-status');
          const results = document.getElementById('animap-leaflet-picker-search-results');
          if (!picker || !status || !results) return;
          const parsed = JSON.parse(resultsJson);
          results.innerHTML = '';
          status.textContent = foundMessage;
          parsed.forEach(item => {
            const entry = document.createElement('button');
            entry.type = 'button';
            entry.textContent = item.name;
            entry.style.display = 'block';
            entry.style.width = '100%';
            entry.style.textAlign = 'left';
            entry.style.padding = '8px 16px';
            entry.style.border = '0';
            entry.style.borderBottom = '1px solid ' + entryDividerColor;
            entry.style.background = 'transparent';
            entry.style.cursor = 'pointer';
            entry.style.font = '14px system-ui, -apple-system, BlinkMacSystemFont, sans-serif';
            entry.addEventListener('click', () => {
              if (picker.map) picker.map.setView([item.latitude, item.longitude], resultZoom);
            });
            results.appendChild(entry);
          });
        }
        ,
    'pl.animap.maps.web.internal.js.pickMapImageForEditor_js_code' : (cancelledMessage, onDone) => 
        {
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = 'image/png,image/jpeg,image/webp,image/svg+xml';
          input.style.position = 'fixed';
          input.style.left = '-10000px';
          input.style.top = '0';
          input.style.width = '1px';
          input.style.height = '1px';
          input.style.opacity = '0';
          document.body.appendChild(input);
          let completed = false;
          const cleanup = () => {
            if (input.parentNode) input.parentNode.removeChild(input);
          };
          const finish = (responseJson, errorMessage) => {
            if (completed) return;
            completed = true;
            cleanup();
            onDone(responseJson, errorMessage);
          };
          input.onchange = () => {
            const file = input.files && input.files[0];
            if (!file) {
              finish(null, cancelledMessage);
              return;
            }
            const supported = ['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'];
            if (!supported.includes(file.type)) {
              finish(null, 'Obsługiwane formaty: PNG, JPEG, WebP albo SVG.');
              return;
            }
            const store = window.__animapMapEditorFiles || new Map();
            window.__animapMapEditorFiles = store;
            const id = String(Date.now()) + '-' + Math.random().toString(16).slice(2);
            store.set(id, { file });
            const reader = new FileReader();
            reader.onload = () => {
              const previewUrl = String(reader.result || '');
              const done = (width, height) => {
                finish(JSON.stringify({
                  id,
                  previewUrl,
                  name: file.name,
                  contentType: file.type,
                  widthPx: width || 0,
                  heightPx: height || 0
                }), null);
              };
              const image = new Image();
              image.onload = () => done(image.naturalWidth, image.naturalHeight);
              image.onerror = () => done(0, 0);
              image.src = previewUrl;
            };
            reader.onerror = () => finish(null, 'Nie udało się odczytać wybranego obrazu.');
            reader.readAsDataURL(file);
          };
          input.oncancel = () => finish(null, cancelledMessage);
          input.click();
        }
        ,
    'pl.animap.maps.web.internal.js.uploadPickedMapImage' : (uploadUrl, pickedImageId, calibrationJson, backgroundColor, markerColor, labelPlateColor, labelTextColor, routeColor, layersJson, pathNetworkVisible, pathNetworkWidth, authorizationHeader, onDone) => 
        {
          const store = window.__animapMapEditorFiles;
          const entry = store && store.get(pickedImageId);
          if (!entry || !entry.file) {
            onDone(null, JSON.stringify({ clientMessage: 'Wybierz obraz mapy przed zapisem.' }));
          } else {
            const formData = new FormData();
            formData.append('image', entry.file, entry.file.name);
            formData.append('calibration', calibrationJson);
            formData.append('backgroundColor', backgroundColor != null ? backgroundColor : '');
            formData.append('markerColor', markerColor != null ? markerColor : '');
            formData.append('labelPlateColor', labelPlateColor != null ? labelPlateColor : '');
            formData.append('labelTextColor', labelTextColor != null ? labelTextColor : '');
            formData.append('routeColor', routeColor != null ? routeColor : '');
            formData.append('layers', layersJson);
            formData.append('pathNetworkVisible', String(pathNetworkVisible));
            formData.append('pathNetworkWidth', String(pathNetworkWidth));
            const headers = {};
            if (authorizationHeader != null) {
              headers['Authorization'] = authorizationHeader;
            }
            fetch(uploadUrl, { method: 'PUT', body: formData, headers: headers })
              .then(async response => {
                const text = await response.text();
                if (!response.ok) {
                  onDone(null, JSON.stringify({
                    statusCode: response.status,
                    contentType: response.headers.get('Content-Type') || '',
                    body: text
                  }));
                  return;
                }
                if (entry.previewUrl) URL.revokeObjectURL(entry.previewUrl);
                store.delete(pickedImageId);
                onDone(text, null);
              })
              .catch(error => onDone(null, JSON.stringify({
                clientMessage: error && error.message ? error.message : String(error)
              })));
          }
        }
        ,
    'pl.animap.maps.web.internal.js.uploadMapImageDraft' : (uploadUrl, pickedImageId, authorizationHeader, onDone) => 
        {
          const store = window.__animapMapEditorFiles;
          const entry = store && store.get(pickedImageId);
          if (!entry || !entry.file) {
            onDone(null, JSON.stringify({ clientMessage: 'Wybierz obraz mapy przed generowaniem sieci ścieżek.' }));
          } else {
            const formData = new FormData();
            formData.append('image', entry.file, entry.file.name);
            const headers = {};
            if (authorizationHeader != null) {
              headers['Authorization'] = authorizationHeader;
            }
            fetch(uploadUrl, { method: 'POST', body: formData, headers: headers })
              .then(async response => {
                const text = await response.text();
                if (!response.ok) {
                  onDone(null, JSON.stringify({
                    statusCode: response.status,
                    contentType: response.headers.get('Content-Type') || '',
                    body: text
                  }));
                  return;
                }
                onDone(text, null);
              })
              .catch(error => onDone(null, JSON.stringify({
                clientMessage: error && error.message ? error.message : String(error)
              })));
          }
        }
        ,
    'pl.animap.maps.web.internal.js.downloadMapPackageFile' : (packageUrl, authorizationHeader, onDone) => 
        {
          const headers = {};
          if (authorizationHeader != null) {
            headers['Authorization'] = authorizationHeader;
          }
          fetch(packageUrl, { method: 'GET', headers: headers })
            .then(async response => {
              if (!response.ok) {
                const text = await response.text();
                onDone(null, JSON.stringify({
                  statusCode: response.status,
                  contentType: response.headers.get('Content-Type') || '',
                  body: text
                }));
                return;
              }
              const disposition = response.headers.get('Content-Disposition') || '';
              const match = /filename="?([^"]+)"?/.exec(disposition);
              const fileName = match ? match[1] : 'zoo-map.zoomap';
              const blob = await response.blob();
              const objectUrl = URL.createObjectURL(blob);
              const anchor = document.createElement('a');
              anchor.href = objectUrl;
              anchor.download = fileName;
              document.body.appendChild(anchor);
              anchor.click();
              document.body.removeChild(anchor);
              setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
              onDone(fileName, null);
            })
            .catch(error => onDone(null, JSON.stringify({ clientMessage: String(error) })));
        }
        ,
    'pl.animap.maps.web.internal.js.absoluteBrowserUrl' : (path) => new URL(path, window.location.href).href,
    'pl.animap.maps.web.internal.js.pickAndUploadMapPackage_js_code' : (uploadUrl, authorizationHeader, cancelledMessage, onDone) => 
        {
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = '.zoomap,application/zip';
          input.style.position = 'fixed';
          input.style.left = '-10000px';
          document.body.appendChild(input);
          let completed = false;
          const finish = (responseJson, errorJson) => {
            if (completed) return;
            completed = true;
            if (input.parentNode) input.parentNode.removeChild(input);
            onDone(responseJson, errorJson);
          };
          input.onchange = () => {
            const file = input.files && input.files[0];
            if (!file) {
              finish(null, JSON.stringify({ clientMessage: cancelledMessage, cancelled: true }));
              return;
            }
            const formData = new FormData();
            formData.append('package', file, file.name);
            const headers = {};
            if (authorizationHeader != null) {
              headers['Authorization'] = authorizationHeader;
            }
            fetch(uploadUrl, { method: 'POST', body: formData, headers: headers })
              .then(async response => {
                const text = await response.text();
                if (!response.ok) {
                  finish(null, JSON.stringify({
                    statusCode: response.status,
                    contentType: response.headers.get('Content-Type') || '',
                    body: text
                  }));
                  return;
                }
                finish(text, null);
              })
              .catch(error => finish(null, JSON.stringify({ clientMessage: String(error) })));
          };
          input.oncancel = () => finish(null, JSON.stringify({ clientMessage: cancelledMessage, cancelled: true }));
          input.click();
        }
        ,
    'pl.animap.maps.web.internal.js.sampleImageColorAtPercent' : (imageUrl, xPercent, yPercent, onDone) => 
        {
          const image = new Image();
          image.crossOrigin = 'anonymous';
          image.onload = () => {
            try {
              const width = image.naturalWidth || image.width;
              const height = image.naturalHeight || image.height;
              const canvas = document.createElement('canvas');
              canvas.width = width;
              canvas.height = height;
              const context = canvas.getContext('2d');
              context.drawImage(image, 0, 0);
              const x = Math.min(width - 1, Math.max(0, Math.round(width * xPercent / 100)));
              const y = Math.min(height - 1, Math.max(0, Math.round(height * yPercent / 100)));
              const pixel = context.getImageData(x, y, 1, 1).data;
              const hex = '#' + [pixel[0], pixel[1], pixel[2]]
                .map(c => c.toString(16).padStart(2, '0'))
                .join('');
              onDone(hex, null);
            } catch (error) {
              onDone(null, 'Nie udało się odczytać koloru z obrazu mapy.');
            }
          };
          image.onerror = () => onDone(null, 'Nie udało się wczytać obrazu mapy.');
          image.src = imageUrl;
        }
        ,
    'pl.animap.sponsors.web.internal.absoluteSponsorLogoUrl' : (path) => new URL(path, window.location.href).href,
    'pl.animap.sponsors.web.internal.pickSponsorLogoImage' : (onDone) => 
        {
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = 'image/png,image/jpeg,image/webp,image/gif,image/svg+xml';
          input.style.position = 'fixed';
          input.style.left = '-10000px';
          input.style.top = '0';
          input.style.width = '1px';
          input.style.height = '1px';
          input.style.opacity = '0';
          document.body.appendChild(input);
          let completed = false;
          const cleanup = () => {
            if (input.parentNode) input.parentNode.removeChild(input);
          };
          const finish = (name, dataUrl, errorMessage) => {
            if (completed) return;
            completed = true;
            cleanup();
            onDone(name, dataUrl, errorMessage);
          };
          input.onchange = () => {
            const file = input.files && input.files[0];
            if (!file) {
              finish(null, null, 'Nie wybrano pliku.');
              return;
            }
            const supported = ['image/png', 'image/jpeg', 'image/webp', 'image/gif', 'image/svg+xml'];
            if (!supported.includes(file.type)) {
              finish(null, null, 'Obsługiwane formaty: PNG, JPEG, WebP, GIF albo SVG.');
              return;
            }
            const reader = new FileReader();
            reader.onload = () => finish(file.name, String(reader.result || ''), null);
            reader.onerror = () => finish(null, null, 'Nie udało się odczytać wybranego pliku.');
            reader.readAsDataURL(file);
          };
          input.oncancel = () => finish(null, null, 'Nie wybrano pliku.');
          input.click();
        }
        ,
    'pl.animap.zoos.web.internal.pickZooCoverImage' : (onDone) => 
        {
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = 'image/png,image/jpeg,image/webp';
          input.style.position = 'fixed';
          input.style.left = '-10000px';
          input.style.top = '0';
          input.style.width = '1px';
          input.style.height = '1px';
          input.style.opacity = '0';
          document.body.appendChild(input);
          let completed = false;
          const cleanup = () => {
            if (input.parentNode) input.parentNode.removeChild(input);
          };
          const finish = (dataUrl, errorMessage) => {
            if (completed) return;
            completed = true;
            cleanup();
            onDone(dataUrl, errorMessage);
          };
          input.onchange = () => {
            const file = input.files && input.files[0];
            if (!file) {
              finish(null, 'Nie wybrano pliku.');
              return;
            }
            const supported = ['image/png', 'image/jpeg', 'image/webp'];
            if (!supported.includes(file.type)) {
              finish(null, 'Obsługiwane formaty: PNG, JPEG albo WebP.');
              return;
            }
            const reader = new FileReader();
            reader.onload = () => finish(String(reader.result || ''), null);
            reader.onerror = () => finish(null, 'Nie udało się odczytać wybranego obrazu.');
            reader.readAsDataURL(file);
          };
          input.oncancel = () => finish(null, 'Nie wybrano pliku.');
          input.click();
        }
        ,
    'pl.animap.zoos.web.internal.absoluteZooCoverImageUrl' : (path) => new URL(path, window.location.href).href,
    'pl.animap.qrcodes.web.internal.downloadPublicFile' : (url, fileName) => 
        {
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.rel = 'noopener';
            document.body.appendChild(a);
            a.click();
            a.remove();
        }
    ,
    'pl.animap.qrcodes.web.internal.browserAbsoluteUrl' : (path) => new URL(path, window.location.href).href,
    'pl.animap.poi.web.internal.absolutePoiUrl' : (path) => new URL(path, window.location.href).href,
    'pl.animap.tickets.web.internal.pickTicketCodeBatchFileRaw' : (onDone) => 
        {
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = '.txt,.csv,text/plain,text/csv';
          input.style.position = 'fixed';
          input.style.left = '-10000px';
          input.style.top = '0';
          input.style.width = '1px';
          input.style.height = '1px';
          input.style.opacity = '0';
          document.body.appendChild(input);
          let completed = false;
          const cleanup = () => {
            if (input.parentNode) input.parentNode.removeChild(input);
          };
          const finish = (text, readFailed) => {
            if (completed) return;
            completed = true;
            cleanup();
            onDone(text, readFailed);
          };
          input.onchange = () => {
            const file = input.files && input.files[0];
            if (!file) {
              finish(null, false);
              return;
            }
            const reader = new FileReader();
            reader.onload = () => finish(String(reader.result || ''), false);
            reader.onerror = () => finish(null, true);
            reader.readAsText(file);
          };
          input.oncancel = () => finish(null, false);
          input.click();
        }
        ,
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.script_$external_prop_getter' : (_this) => _this.script,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (wasmMemory, ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmMemory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.jsFetchWithSignal' : (url, signal) => window.fetch(url, { signal }),
    'org.jetbrains.compose.resources.AbortController_$external_fun' : () => new AbortController(),
    'org.jetbrains.compose.resources.signal_$external_prop_getter' : (_this) => _this.signal,
    'org.jetbrains.compose.resources.abort_$external_fun' : (_this, ) => _this.abort(),
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'androidx.navigation.refBrowserWindow' : () => window,
    'androidx.navigation.location_$external_prop_getter' : (_this) => _this.location,
    'androidx.navigation.history_$external_prop_getter' : (_this) => _this.history,
    'androidx.navigation.console_$external_prop_getter' : (_this) => _this.console,
    'androidx.navigation.origin_$external_prop_getter' : (_this) => _this.origin,
    'androidx.navigation.pathname_$external_prop_getter' : (_this) => _this.pathname,
    'androidx.navigation.hash_$external_prop_getter' : (_this) => _this.hash,
    'androidx.navigation.state_$external_prop_getter' : (_this) => _this.state,
    'androidx.navigation.decodeURIComponent_$external_fun' : (p0) => decodeURIComponent(p0),
    'androidx.navigation.state_$external_prop_getter_1' : (_this) => _this.state,
    'androidx.navigation.pushState_$external_fun' : (_this, p0, p1, p2) => _this.pushState(p0, p1, p2),
    'androidx.navigation.replaceState_$external_fun' : (_this, p0, p1, p2) => _this.replaceState(p0, p1, p2),
    'androidx.navigation.addEventListener_$external_fun' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'androidx.navigation.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'androidx.navigation.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'androidx.navigation.encodeURIComponent_$external_fun' : (p0) => encodeURIComponent(p0),
    'androidx.navigation.compose.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.navigation.compose.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'pl.animap.app.di.runtimeApiBaseUrl' : () => 
        {
            return globalThis.__ANIMAP_CONFIG__?.apiBaseUrl || "";
        }
        ,
    'pl.animap.app.internal.jsJodaTimeZoneDatabase_$external_prop_getter' : () => _ref_QGpzLWpvZGEvdGltZXpvbmU_.default
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        memory: new WebAssembly.Memory({ initial: 0 }),
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    